import {NamaRouterInstance} from "../routing/NamaRouter";
import {ajaxJSON, ajaxJSONWithoutError, isNotEmptyOrNull} from "../common/NamaCommon";
import * as NamaURLS from "../constants/NamaURLS";
import {getName, translateMessage} from "../common/Translator";
import {stringify} from "../common/NamaJSON";
import * as notifier from "../common/ErrorsNotification";

export function SignDocuments(onlySelected) {
    let currentPresenter = NamaRouterInstance.currentPresenter;
    if (!currentPresenter)
        return;
    if (currentPresenter.hasChanges()) {
        notifier.showError(translateId("recordMustBeSaved"));
        return;
    }
    let id = currentPresenter.getFieldValue("id");
    let request = {
        submissionDocId: id,
        onlySelected: onlySelected
    };
    ajaxJSON(NamaURLS.UpdateTaxAuthJson, request, (data) => {
        if (!data) {
            notifier.showError(getName("الرجاء التأكد من تفعيل أوبشن إرسال المستندات موقعه إلكترونيا الموجود في إعدادت مصلحة الضرائب",
                "Please mark option Send Documents With Signature in tax payer config"));
            return;
        }
        let list = json.decode(data);
        for (var response in list) {
            executeSignCall(response);
        }

        function executeSignCall(response) {
            let port = "7994";
            let url = "http://localhost:" + port;
            if (isNotEmptyOrNull(response['']))
                url = response['einvoiceSignerUrl'];
            if (!url.endsWith("/"))
                url += '/';
            url += 'signDocuments';
            let request = {
                actualData: response['jsonData'],
            }
            if (isNotEmptyOrNull(response['einvoiceSignerPin']))
                request.authorization = btoa(`${response['einvoiceSignerType']}:${response['einvoiceSignerPin']}`);
            ajaxJSONWithoutError(url, request, (resp) => {
                let request = {
                    responseBody: stringify(resp),
                    submissionDocId: id,
                    onlySelected: onlySelected
                };
                ajaxJSON(NamaURLS.SignDocuments, request, (data) => {
                    if (data != null) {
                        notifier.showError(data);
                        notifier.showErrors("There is no connection on port " + port + ", please make sure that the e-signer server is running. <br/>You can download the setup file from <a href='https://www.namasoft.com/bin/eSignerSetup.msi' target='_blank'>here</a>" +
                            "E SEAL:" + egyptTrustInfo() + "<br/>MCDR: " + misrMakasaInfo()
                        );
                        return;
                    }
                    notifier.showInfo(translateMessage("operationSuccessfull"), "Documents were signed successfully");
                    currentPresenter.onRefresh();
                })
            }, (error) => {
                notifier.showErrors("There is no connection on port " + port + ", please make sure that the e-signer server is running. <br/>You can download the setup file from <a href='https://www.namasoft.com/bin/eSignerSetup.msi' target='_blank'>here</a>" +
                    "E SEAL:" + egyptTrustInfo() + "<br/>MCDR: " + misrMakasaInfo()
                );
            });
        }
    });
}

export function egyptTrustInfo() {
    return "<br/><a href='https://www.incometax.gov.eg/invoice/doc/esign/v_3.11.000.zip' target='_blank'>ITIDA Web Sign Version 3.11</a>" +
        "<br/><a href='https://www.incometax.gov.eg/invoice/doc/esign/Digital-Signature-Setup.zip' target='_blank'>Egypt Trust Activation</a>";
}

export function misrMakasaInfo() {
    return "<br/>MCDR: <a href='http://www.mcdr-ca.com/AWP.aspx'>MCDR Settings</a>";

}